const QUANTITY_ONE_TRANSLATION = 'one';
const QUANTITY_FEW_TRANSLATION = 'few';
const QUANTITY_OTHER_TRANSLATION = 'other';

const QUANTITY_ONE = 1;
const QUANTITY_FEW_THRESHOLD = 4;

const TRANSLATION_INFECTION_SEPARATOR = '.';

export const getTranslationKeyWithInflection = (translation, quantity) => {
    if (!translation) {
        return '';
    }

    if (!quantity || isNaN(quantity) || quantity < 0) {
        return `${translation}${TRANSLATION_INFECTION_SEPARATOR}${QUANTITY_OTHER_TRANSLATION}`;
    }

    return `${translation}${TRANSLATION_INFECTION_SEPARATOR}${
        quantity === QUANTITY_ONE
            ? QUANTITY_ONE_TRANSLATION
            : quantity <= QUANTITY_FEW_THRESHOLD
            ? QUANTITY_FEW_TRANSLATION
            : QUANTITY_OTHER_TRANSLATION
    }`;
};
